import { getThemeNodeFontFamily } from './themes';
export const IDEA_FONTS = [
  { id: 'theme', name: 'Theme font', family: null },
  { id: 'quicksand', name: 'Quicksand', family: "'Quicksand', sans-serif" },
  { id: 'handwritten', name: 'Handwritten', family: "'Patrick Hand', cursive" },
  { id: 'sans', name: 'Sans serif', family: 'Arial, Helvetica, sans-serif' },
  { id: 'serif', name: 'Serif', family: "Georgia, 'Times New Roman', serif" },
  { id: 'mono', name: 'Monospace', family: "'Courier New', Courier, monospace" },
];
export const getIdeaFontFamily = (id, theme) => IDEA_FONTS.find(font => font.id === id)?.family || getThemeNodeFontFamily(theme);
export const getIdeaFontSize = value => Number.isFinite(value) && value >= 8 && value <= 96 ? value : 14;
